const LangCardDetails = {
	"cardDetails._title": ["MY CARDS", "កាត​ខ្ញុំ"],
	"cardDetails.button._transferBalance": ["Transfer Balance", "ផ្ទេរ​ទឹក​ប្រាក់​"],
	"cardDetails.reportLostCard": ["Report Lost Card", "រាយ​ការណ៍​បាត់​កាត"],
	"cardDetails.removeCard": ["Remove Card", "លុប​កាត"],
	"cardDetails.cards": ["CARDS", "កាត"],
	"cardDetails.storedValue": ["CARD BALANCE", "ទឹក​ប្រាក់​ក្នុង​កាត"],
	"cardDetails.newValue": ["NEW VALUE", "​ទឹក​ប្រាក់​ថ្មី"],
	"cardDetails.status": ["STATUS", "ស្ថាន​ភាព"],
	"cardDetails.defaultCard": ["Default Card", "កាត​ចម្បង​"],
	"cardDetails.message._removeCardConfirmation": [
		"Are you sure you want to remove this card?",
		"តើ​លោក​អ្នក​ ពិត​ជា​ចង់​លុប​កាត​នេះ​​?",
	],
	"cardDetails.message._hasStoreBalance": [
		"You cards still have balance. Please use it or transfer to another before removing. Do you want to redirect to Transfer Balance page?",
		"កាត​របស់​លោក​អ្នក​នៅ​មាន​ទឹក​ប្រាក់​​ ។​ សូម​ប្រើ​ឲ្យ​អស់ ឬ​ផ្ទេរ​​ទឹក​ប្រាក់ ទៅ​កាត​មួយ​ទៀត​មុន​នឹង​លុប​ចោល ។​​ តើ​លោក​អ្នក​​ ចង់​ចូល​ទៅ​ទំព័រ​ផ្ទេរ​ទឹក​ប្រាក់​ឬ​ទេ?",
	],
	"cardDetails.message._reportLostCardConfirmation": [
		"Are you sure you want to report this card as lost or stolen?",
		"តើ​លោក​អ្នក​ពិត​ជា​ចង់​រាយ​ការណ៍​ថា​ កាត​នេះ​បាន​បាត់ ឬ​ត្រូវ​បាន​លួច​?",
	],
	"cardDetails.message._transferBalanceOfSuspendedCard": [
		"Do you want to transfer the balance of your suspended card?",
		"តើ​លោក​អ្នក​ចង់​ផ្ទេរ​ទឹក​ប្រាក់​​ចេញ​ពី​កាត​ដែល​ត្រូវ​បាន​បិទ​?",
	],
	"cardDetails.message._reportCardIsDefault": [
		"This is default card. Please select other card as default before proceeding to report.",
		"vi_This is default card. Please select other card as default before proceeding to report.",
	],
	"cardDetails.message._verifyAddress": [
		"We can send you a replacement card, please verify your address.",
		"យើង​ខ្ញុំ​អាច​ផ្តល់​កាត​ថ្មី​ជូន​លោក​អ្នក ។ សូម​បញ្ជាក់​ពី​អាសយដ្ឋាន​របស់​លោក​អ្នក ។",
	],
	"cardDetails.transactionHistory": ["Transaction History", "ប្រវត្តិ​​​ប្រតិបត្តិការ"],
	"cardDetails.message.selectAnOutletToCollectYourCard": [
		"Select an outlet to collect your card",
		"Select an outlet to collect your card",
	],
}

export default LangCardDetails



// WEBPACK FOOTER //
// ./src/resources/pages/LangCardDetails.js